module.exports = __webpack_public_path__ + "img/formFb.cb8447ba.svg";